import api from './api';

const objectsService = {
  // List objects (with optional filters)
  list: async (params = {}) => {
    const response = await api.get('/objects', { params });
    return response.data;
  },

  // Get single object
  get: async (id) => {
    const response = await api.get(`/objects/${id}`);
    return response.data;
  },

  // Create a new object
  create: async (data) => {
    const response = await api.post('/objects', data);
    return response.data;
  },

  // Update an object
  update: async (id, data) => {
    const response = await api.put(`/objects/${id}`, data);
    return response.data;
  },

  // Soft-delete an object. Backend sets deletedAt; the row is hard-purged
  // by Mongo TTL after 48h. Use restore() to undo before then.
  delete: async (id) => {
    const response = await api.delete(`/objects/${id}`);
    return response.data;
  },

  // Un-delete a soft-deleted object. 404 if it was already TTL-purged.
  restore: async (id) => {
    const response = await api.post(`/objects/${id}/restore`);
    return response.data;
  },

  // Add a reference image to an object
  addImage: async (id, imageData) => {
    const response = await api.post(`/objects/${id}/images`, imageData);
    return response.data;
  },

  // Remove a reference image from an object
  removeImage: async (id, imageId) => {
    const response = await api.delete(`/objects/${id}/images/${imageId}`);
    return response.data;
  },

  // Generate a TTS voice line for a character object using its assigned voiceId.
  // Returns { audioUrl, durationMs, characterCount } on success. ElevenLabs
  // calls can take a few seconds; bump the timeout above the default 60s.
  generateVoiceLine: async (id, text) => {
    const response = await api.post(
      `/objects/${id}/voice-line`,
      { text },
      { timeout: 120000 }, // 2 min ceiling — TTS for ~2500 chars max
    );
    return response.data;
  },
};

export default objectsService;
